export default "__VITE_ASSET__DdH17tS$__"